export const buildDuplicateSelection = (target_object_type, object) => {
  if (
    target_object_type === "elements" &&
    object &&
    object.element_type === "row"
  ) {
    const firstSection = Object.values(object.sections || {})
      .filter((section) => section.content_toggle_item_id == null)
      .sort((a, b) => a.position - b.position)[0];

    if (firstSection) {
      return {
        object_type: "sections",
        object_id: firstSection.id,
        collapse: "first",
        editing: false,
      };
    }
  }

  return {
    object_type: target_object_type,
    object_id: object.id,
    tab:
      target_object_type === "steps"
        ? "Logic"
        : target_object_type === "sections"
        ? "Section"
        : "Content",
    collapse: undefined,
    panel_closed: undefined,
  };
};
